<div class="notificationsWrapper">
    @for (notification of notifications; track notification.id) {
        <app-notification-item
            [notification]="notification"
            (notificationChange)="onNotificationChange()"
            [isPanel]="isPanel"
        ></app-notification-item>
    }
    @if (paginationConfig && !canGoNext()) {
        <div class="allLoaded">
            <div class="content">
                <div class="icon" [innerHTML]="notificationIcon"></div>
                <div class="text">That’s all your notifications from the last 30 days.</div>
            </div>
        </div>
    }
    @if (paginationConfig) {
        <div class="scrollRef" libIntersectionListener (intersectionListener)="goNext()"></div>
    }
</div>
